export const dummyResult = Object.freeze([])
